export interface AddressParts {
    address_line_1?: string | null;
    address_line_2?: string | null;
    city?: string | null;
    postcode?: string | null;
}

export const formatAddress = (address: AddressParts | null | undefined): string | undefined => {
    const parts = [address?.address_line_1, address?.address_line_2, address?.city, address?.postcode].filter(Boolean);
    return parts.length > 0 ? parts.join(', ') : undefined;
};
